import HttpService from 'services/HttpService';
import { trackAction } from 'helpers/trackingOM';
import NotificationBar from 'components/notifications/NotificationBar';
import { getLocale } from 'services/LocalizationService.js';
import FloatingTooltip from 'components/watchlist/FloatingTooltip';

const ADD = 'add';
const REMOVE = 'remove';
const IN_WATCH_LIST_CLASS = 'in_watchlist';
const ADD_TO_MY_LIST = 'Add to My List';
const REMOVE_FROM_MY_LIST = 'Remove from My List';
const MOVIES = 'movies';
const MOVIE = 'movie';
const SHOWS = 'shows';
const SHOW = 'show';
const ADD_TRACK_WATCHLIST_ACTION = 'trackAddWatchList';
const REMOVE_TRACK_WATCHLIST_ACTION = 'trackRemoveWatchList';
const CONTENT_SHOW = 'show';
const CONTENT_MOVIE = 'movie';

export default class AddToMyListFromYAML {
    constructor() {
        this._http = new HttpService();
        //ensure click event listener is only set up once per swiper slide
        this.swiperSlidesCache = new Set();
        this._isSafari = this.isSafari();
        this.contentType = null;
        this._floatingTooltip = null;
        this._notificationBar = null;
        this._apiErrorMsg = getLocale('sorry_we_cant_add_or_remove_items_right_now');
        this._yourlistIsFullMsg =
            '<strong>' +
            getLocale('your_list_is_full') +
            '</strong><br>' +
            getLocale('please_remove_an_item_before_adding_another');
        this._notificationBar = new NotificationBar();
        this._floatingTooltip = new FloatingTooltip(
            CBS.Registry.Features.movie_detail_page
                ? this.contentType === CONTENT_MOVIE
                : this.contentType === CONTENT_SHOW,
        );
    }

    /**
     * on Page Load, load yaml carousel by ID: related-shows-carousel
     * then loads all swiper slides then sets click event on each of swiper slide
     * this works only on PHP build carousel, which targets yaml shows on shows page
     * won't work with JS carousel since on page load, the body of carousel might be empty: no swiper slides set up yet.
     */
    onRun() {
        const YMALCarousel = document.getElementById('related-shows-carousel');
        this.setCarouselTrackingData(YMALCarousel);

        if (YMALCarousel) {
            const swiperSlides = YMALCarousel.querySelectorAll(
                '.video-carousel-box .swiper-container .swiper-slide',
            );
            this.setClickActionsOnWatchCTAWrappers(swiperSlides);
        }
    }

    /**
     * directly copy from
     * @param YMALCarousel, carouselTitle
     * get carousel position on a page
     */
    getPositionRowNum(YMALCarousel, carouselTitle) {
        const carousels = document.querySelectorAll('.hero__wrapper, .js-le-carousel, .grid-view');
        if (carousels) {
            for (
                let carouselPosRowNum = 0;
                carouselPosRowNum < carousels.length;
                carouselPosRowNum++
            ) {
                const title = carousels[carouselPosRowNum].querySelector('.video-section-title');
                if (title && title.innerHTML.trim() === carouselTitle) {
                    return carouselPosRowNum;
                }
            }
        }
    }

    isMobileLandscapeMax() {
        let windowWidth = this._isSafari ? $(window).width() : $(window).outerWidth();
        return windowWidth <= 550;
    }

    isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    getComponentElement() {
        if (this._) {
            return $(this._).find('.watchlist_wrapper')[0];
        } else {
            return document.querySelector('div.watchlist_wrapper');
        }
    }

    /**
     * @param YMALCarousel
     * set carousel tracking information
     */
    setCarouselTrackingData(YMALCarousel) {
        const carouselTitle = YMALCarousel.querySelector('.video-section-title').innerHTML.trim();
        this.carouselTracking = {
            carouselId: YMALCarousel.getAttribute('id'),
            rowHeaderTitle: carouselTitle,
            posRowNum: this.getPositionRowNum(YMALCarousel, carouselTitle).toString(),
        };

        return this;
    }

    /**
     * @param swiperSlides
     * this.swiperSlidesCache:ensure click event listener is only set up once per swiper slide
     * set up click event on each Swiper Slide
     * if this yaml show/movies in watchList, click on will remove it, changing icon to Plus Mark
     * if this yaml show/movies in not watchList, click on will add it, changing icon to Check Mark, adds in_watchlist to wrapper.
     * @param refreshRecommendBasedOnMyListCarousel
     * @param removeFromRecommendedMyList
     * @param forceAddCLickEvent
     */
    //// START A/B TEST PLGRWEB-1649-add to my list button from my list page
    setClickActionsOnWatchCTAWrappers(
        swiperSlides,
        refreshRecommendBasedOnMyListCarousel = null,
        removeFromRecommendedMyList,
        forceAddCLickEvent = false,
    ) {
        // END A/B TEST PLGRWEB-1649-add to my list button from my list page
        const thisClass = this;

        // Add click event listener to each button
        swiperSlides.forEach((slide, swiperIndex) => {
            const slideIndex = slide.getAttribute('data-swiper-slide-index') ?? swiperIndex;
            // START A/B TEST PLGRWEB-1649-add to my list button from my list page
            if (!this.swiperSlidesCache.has(slideIndex) || forceAddCLickEvent) {
                // END A/B TEST PLGRWEB-1649-add to my list button from my list page
                const watchCtaWrapper = slide.querySelector('a .thumb-wrapper .watchlist_wrapper');
                thisClass
                    .setUpToolTipMouseEnter(watchCtaWrapper)
                    .setUpToolTipMouseLeave(watchCtaWrapper);
                watchCtaWrapper.addEventListener('click', async function (evt) {
                    evt.preventDefault();

                    // START A/B TEST PLGRWEB-1649-add to my list button from my list page
                    if (removeFromRecommendedMyList) {
                        await removeFromRecommendedMyList(evt);
                    }
                    // END A/B TEST PLGRWEB-1649-add to my list button from my list page

                    const watchListWrapper = this;
                    //contentType: show/movies
                    const contentType = watchListWrapper.getAttribute('data-content-type');
                    //contentId: showId/ContentId of Movie
                    const contentId = watchListWrapper.getAttribute('data-content-id');
                    //watchListCta wrapper
                    const watchListCta = watchListWrapper.querySelector('.watchlistCta');
                    //determine either add/remove this yaml show/movies
                    const contentAction = watchListCta.classList.contains(IN_WATCH_LIST_CLASS)
                        ? REMOVE
                        : ADD;
                    //dynamic build addToMyListURL
                    const addToMyListUrl = `${CBS.Registry.region.prefix}/user-profile/xhr/watchlist/${contentType}/${contentId}/${contentAction}/`;

                    trackAction(
                        watchListCta.classList.contains(IN_WATCH_LIST_CLASS)
                            ? REMOVE_TRACK_WATCHLIST_ACTION
                            : ADD_TRACK_WATCHLIST_ACTION,
                        thisClass.buildTrackingAddToMyListAction(
                            watchListWrapper.parentNode.parentNode,
                            contentType,
                        ),
                    );

                    thisClass._http.doGet(addToMyListUrl).then((addToMyListResp) => {
                        if (addToMyListResp?.success) {
                            const watchCTAClassList = watchListCta.classList;
                            const tooltip = watchListWrapper.querySelector('span.tooltip');
                            tooltip.textContent =
                                contentAction === ADD ? REMOVE_FROM_MY_LIST : ADD_TO_MY_LIST;
                            contentAction === REMOVE
                                ? watchCTAClassList.remove(IN_WATCH_LIST_CLASS)
                                : watchCTAClassList.add(IN_WATCH_LIST_CLASS);

                            // START A/B TEST PLGRWEB-1649-add to my list button from my list page
                            if (refreshRecommendBasedOnMyListCarousel) {
                                refreshRecommendBasedOnMyListCarousel(evt);
                            }
                            // END A/B TEST PLGRWEB-1649-add to my list button from my list page
                        } else {
                            //ERROR When limit is reached or failed to update
                            console.error('Failed to update the watchlist:', addToMyListResp);
                            if (addToMyListResp?.data.limit_reached) {
                                if (thisClass.isMobileLandscapeMax()) {
                                    thisClass._floatingTooltip.slideIn(addToMyListResp?.message);
                                } else {
                                    const tooltip = watchListWrapper.querySelector('span.tooltip');
                                    tooltip.classList.add('too-many');
                                    tooltip.innerHTML = thisClass._yourlistIsFullMsg;
                                    thisClass.showErrorMessage(addToMyListResp?.message);
                                }
                            } else {
                                thisClass.showErrorMessage();
                            }
                        }
                    });
                });
                this.swiperSlidesCache.add(slideIndex);
            }
        });

        return this;
    }

    buildTrackingAddToMyListAction(anchorLink, contentType) {
        const aaLinkData = anchorLink.getAttribute('aa-link').split('|');
        const isMovie =
            contentType === MOVIE ||
            (CBS?.Registry?.pageType === 'MY_LIST' && aaLinkData[16] !== '');

        if (!isMovie && aaLinkData[4].includes('-')) {
            aaLinkData[4] = aaLinkData[4].split('-')[0] ?? '';
        }

        return {
            pageType: CBS?.Registry?.pageType === 'MY_LIST' ? 'my_list' : isMovie ? MOVIE : SHOW,
            carouselId: aaLinkData[0] ?? '',
            carouselContentType: isMovie ? MOVIE : SHOW,
            carouselModel: isMovie ? MOVIES : SHOWS,
            carouselLink: anchorLink.getAttribute('href') ?? '',
            showSeriesId: !isMovie
                ? aaLinkData[11] !== ''
                    ? aaLinkData[11]
                    : anchorLink.getAttribute('id')
                : '',
            showSeriesTitle: !isMovie ? (aaLinkData[4] ?? '') : '',
            movieId: isMovie ? (anchorLink.getAttribute('id') ?? '') : '',
            movieTitle: isMovie
                ? (anchorLink.getAttribute('data-tracking').split('|')[0] ?? '')
                : '',
            contentLocked: aaLinkData[23] ? aaLinkData[23] : '0',
            posColNum:
                aaLinkData[3].toString() ??
                anchorLink.parentNode.getAttribute('data-swiper-slide-index').toString() ??
                '',
            ...this.carouselTracking,
        };
    }

    setUpToolTipMouseEnter(watchListWrapper) {
        const thisClass = this;
        watchListWrapper.addEventListener('mouseenter', () => {
            //watchListCta wrapper
            const watchListCta = watchListWrapper.querySelector('.watchlistCta');
            const tooltip = watchListWrapper.querySelector('span.tooltip');
            tooltip.textContent = watchListCta.classList.contains(IN_WATCH_LIST_CLASS)
                ? REMOVE_FROM_MY_LIST
                : ADD_TO_MY_LIST;
            tooltip.classList.add('visible');
        });
        return this;
    }

    setUpToolTipMouseLeave(watchListWrapper) {
        watchListWrapper.addEventListener('mouseleave', () => {
            const tooltip = watchListWrapper.querySelector('span.tooltip');
            tooltip.classList.remove('visible');
            tooltip.classList.remove('too-many');
        });
        return this;
    }

    showErrorMessage(msg = this._apiErrorMsg) {
        this._notificationBar.showMessage(msg, false);
    }
}

/**
 * initiate this class instance: AddToMyListFromYAML
 */
export const initializedAddToMyListFromYAMLInstance = () => {
    return new AddToMyListFromYAML();
};

/**
 * initiate this class instance: AddToMyListFromYAML
 */
export const initializedAddToMyListFromYAML = () => {
    initializedAddToMyListFromYAMLInstance().onRun();
};
